import {handlers} from "./events";
function eCommerceAnalyticsHandler({type, payload}) {
  const eventHandler = handlers[type];
  if (eventHandler) {
    eventHandler(payload);
  }
}

export default eCommerceAnalyticsHandler;
